import { render, staticRenderFns } from "./CreateBeneficiary.vue?vue&type=template&id=70c87b9f&"
import script from "./CreateBeneficiary.vue?vue&type=script&lang=js&"
export * from "./CreateBeneficiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports